import React from 'react'

export default function Events() {
  return <>
    <div class="page-wrapper sec-mar">
        <article
          id="post-15"
          class="post-15 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="15"
              class="elementor elementor-15"
            >
              <section
                class="elementor-section elementor-top-section elementor-element elementor-element-7570cb6 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                data-id="7570cb6"
                data-element_type="section"
              >
                <div class="elementor-container elementor-column-gap-no">
                  <div
                    class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-0751275"
                    data-id="0751275"
                    data-element_type="column"
                  >
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div
                        class="elementor-element elementor-element-96da640 elementor-widget elementor-widget-spinner_slider"
                        data-id="96da640"
                        data-element_type="widget"
                        data-widget_type="spinner_slider.default"
                      >
                        <div class="elementor-widget-container">
                          <script></script>

                          <div class="banner-section2">
                            <div class="banner2-spring1"></div>
                            <div class="banner2-spring2"></div>
                            <div class="banner2-circle1"></div>
                            <div class="banner2-circle2"></div>
                            {/* <img
                              decoding="async"
                              src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-vector.png"
                              class="banner2-vector"
                              alt="image"
                            /> */}

                            
                            <div class="swiper banner2">
                              <div class="swiper-wrapper">
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  <img
                                    decoding="async"
                                    // src={topnotch_6}
                                    src="https://wallpapercave.com/wp/wp10715843.jpg"
                                    class="slider-bg"
                                    alt="image"
                                  />
                                  <div class="container">
                                    <div class="row d-flex justify-content-center align-items-center">
                                      <div class="col-xl-7 col-lg-10">
                                        <div class="banner2-content">
                                          <span>
                                            WE ARE TOP NOTCH MEDIA WORKS
                                          </span>
                                          <h2>Events
</h2>

                                         
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="swiper-slide d-flex justify-contnent-center align-items-center">
                                  {/* <img
                                    decoding="async"
                                    src="https://www.spinner-wp.egenslab.com/wp-content/uploads/2022/08/banner2-bg2-1.png"
                                    class="slider-bg"
                                    alt="image"
                                  /> */}
                                  
                                </div>
                              </div>
                            </div>
                            <div class="banner2-pagination d-flex justify-content-center flex-row align-items-center gap-2"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>

       {/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>Event Services


</b></h1>
<p>An important event, as in a person’s career, the history of a nation, or the advancement of knowledge in a field; a turning point.




</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Product Launch


-</span>
                    <h3 className="text-white">
                    Product Launch


                    </h3>
                    <p class="para mb-0 ">
                    A product launch serves many purposes for an organization— giving customers the chance to buy the new product  is only one of them.

                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://media.istockphoto.com/id/1145940285/photo/product-launch-motivational-business-marketing-words-quotes-concept.jpg?b=1&s=170667a&w=0&k=20&c=4L6UsxE4Mw_uZCC8D1RW1JSuF8Ab2fhwU5ifU-FAehw=" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YnVzaW5lc3MlMjBsYXVuY2h8ZW58MHx8MHx8&w=1000&q=80" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Corporate Launch



-</span>
                    <h3  className="text-white">
                    Corporate Launch




                    </h3>
                    <p class="para mb-0 ">
                    If you want to be successful, you need to take steps to plan and execute a well-timed, memorable launch  that will bring your product to the attention of more people in more locations.


.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Festive Funds

-</span>
                    <h3  className="text-white">
                    Festive Funds

                    </h3>
                    <p class="para mb-0 ">
                    As the season is all about indulging, sharing and gifting, you have to decide in advance how much you plan to spend. Write a list of every person you need to buy a gift for, including yourself and set a budget.





                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://media.istockphoto.com/id/1457287703/photo/2023-january-new-year-calendar-on-the-table-at-office-concept-of-new-beginning-and-holidays.jpg?s=612x612&w=0&k=20&c=vebTjZqnl429SiWGl6dK1owgCAD3zjDe3k8bGzGeZvg=" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://thumbs.dreamstime.com/b/pr-public-relations-advertising-advertisement-hand-pressing-button-screen-216427222.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Public Relation Camps



-</span>
                    <h3  className="text-white">
                    Public Relation Camps



                    </h3>
                    <p class="para mb-0 ">
                    A public relations campaign is a series of activities that are planned in advance and relate to a specific goal. This contrasts with other areas of PR, such as general ongoing publicity tactics, paid advertising, and reacting to events.

.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    
  </>
}
